import React from "react";
import { useAddEntity } from "../../../../../../utils/CustomFunctions";
import { FaSyncAlt } from "react-icons/fa";
import { Tooltip } from "antd";
import { Link, useParams } from "react-router-dom";
import SelectBox from "../../../../../global/SelectBox";
import { useSelector } from "react-redux";

const AddCountries = () => {
  const { countries, loading } = useSelector((state) => state.AllData);
  const initialState = {
    name: "",
    code: "",
    flag: "",
  };

  // validate fields
  const validateFields = (values) => {
    let newErrors = {};

    if (!values.name) newErrors.name = "This value should not be null.";
    return newErrors;
  };
  const { isPending, errors, newEntity, handleCountrySelectBox, handleSubmit } =
    useAddEntity(
      "admin",
      "country",
      "countries",
      initialState,
      validateFields,
      "/en/dashboard/administrator/manage-countries"
    );

  return (
    <div className="card">
      <div className="card-body">
        <form className="signform" onSubmit={handleSubmit}>
          <div className="mb-4">
            <div className="mb-1">
              <label htmlFor="name" className="form-label fw-600">
                Name<span style={{ color: "red" }}>*</span>
              </label>
              <SelectBox
                name="code"
                options={countries}
                val={newEntity?.code}
                change={handleCountrySelectBox}
              />
            </div>
            {errors.name && (
              <small className="text-danger d-block">{errors.name}</small>
            )}
          </div>

          <div className="mb-4">
            <div className="mb-1">
              <label htmlFor="code" className="form-label fw-600">
                Country code
              </label>
            </div>
            <input
              type="text"
              name="code"
              id="code"
              className="form-control"
              value={newEntity?.code}
              readOnly
            />
          </div>
          {newEntity?.flag && (
            <img src={newEntity?.flag} className="img-thumbnail img-50-50" />
          )}

          <div className="form-group mt-3 mb-3">
            <button
              className="btn btn-dark rounded-5"
              disabled={isPending ? "disabled" : ""}
              type="submit"
            >
              {isPending ? <FaSyncAlt className="spinIcon" /> : "save"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddCountries;
